export interface ServiceOption {
    option: string;
    value: string | Mri.Contracts.ServiceLevel;
    type: 'serviceLevel' | 'contractOption';
}

export const ServiceOptions: ServiceOption[] = [
    { option: 'Warranty(Legacy)', value: Mri.Contracts.ServiceLevel.Warranty, type: 'serviceLevel' },
    { option: 'SmartVu® Depot', value: Mri.Contracts.ServiceLevel.SmartVuDepot, type: 'serviceLevel' },
    { option: 'SmartVu® Advanced', value: Mri.Contracts.ServiceLevel.SmartVuAdvanced, type: 'serviceLevel' },
    { option: 'SmartVu® Custom', value: Mri.Contracts.ServiceLevel.SmartVuCustom, type: 'serviceLevel' },
    { option: 'SmartVu® Portal', value: Mri.Contracts.ServiceLevel.SmartVuPortal, type: 'serviceLevel' },
    { option: 'SmartVu® Gold', value: Mri.Contracts.ServiceLevel.SmartVuGold, type: 'serviceLevel' },
    { option: 'SmartVu® Platinum', value: Mri.Contracts.ServiceLevel.SmartVuPlatinum, type: 'serviceLevel' },
    {
        option: 'MRI Standard Warranty',
        value: Mri.Contracts.ServiceLevel.MRIStandardWarranty,
        type: 'serviceLevel',
    },
    { option: 'Out of Warranty', value: Mri.Contracts.ServiceLevel.OutOfWarranty, type: 'serviceLevel' },
];
